import Phaser, {
	Data
} from 'phaser'


import {
	Plugin as NineSlicePlugin
} from 'phaser3-nineslice'

import TagTextPlugin from 'phaser3-rex-plugins/plugins/tagtext-plugin.js';

import Preloader from './scenes/Preloader';
import Menu from './scenes/Menu';
import Intro from './scenes/Intro';
import World from './scenes/World';
import Guide from './scenes/Guide';
import Utils from './scenes/Utils';
import Sounds from './scenes/Sounds';
import Overlay from './scenes/locations/Overlay';
import AuntyKewa from './scenes/locations/AuntyKewa';
import XMLLoader from './scenes/XMLLoader';
import Wharenui from './scenes/locations/Wharenui';
import Navigate from './scenes/Navigate';
import KaumatuaPorch from './scenes/locations/KaumatuaPorch';
import Kaumatua from './scenes/locations/Kaumatua';
import Dictionary from './scenes/locations/Dictionary';
import Matching from './scenes/locations/Matching';

//*** VARIABLES ***/
//the design was made in an 800x600 layout
const layoutWidth = 800;
const layoutHeight = 600;
//find the best resolution possible
let deviceWidth = window.screen.width;

//set a cap for cpu purposes on extra large monitors
if (deviceWidth > 2720) deviceWidth = 2720;

//*** Pick a Scale for all the vector graphics to rasterise at ***/
//let scaleIt = Math.ceil(deviceWidth / layoutWidth);
let scaleIt = Math.round(deviceWidth / layoutWidth);
if (scaleIt < 1) scaleIt = 1;

let isEnglish = true;
//Resizing the app keeping 4:3 and based on users device resolution (not browser size) 
let gameWidth = layoutWidth * scaleIt;
let gameHeight = layoutHeight * scaleIt;


/*** FOR TESTING LAYOUT 
gameWidth = 800;
gameHeight = 600;
scaleIt = 1;
***/
const padding = 22 * scaleIt;


//An index scene to start up the global registry between scenes
export default class Index extends Phaser.Scene {
	create() {
		//scaleIt is now global, start the preloader
		this.registry.set('scaleIt', scaleIt);
		this.registry.set('isEnglish', isEnglish);
		this.registry.set('padding', padding);


		this.detectMobile();

		this.scene.launch('preloader');
		//this.scene.get('preloader').events.on('ready', this.startUp, this);
	}
	//startUp() {
	//console.log("LISTENER READY");


	//	}


	//Basic mobile vs desktop detection
	detectMobile() {

		var isMobile = window.orientation > -1;
		this.registry.set('isMobile', isMobile);
		//if (isMobile) this.scale.startFullscreen();

		//alert(isMobile ? 'Mobile' : 'Not mobile');
	}

}

//Setup the Phaser Game
const config = {
	type: Phaser.AUTO,
	backgroundColor: '#000',
	scale: {
		parent: 'main',
		autoCenter: Phaser.Scale.CENTER_BOTH,
		mode: Phaser.Scale.FIT,
		width: gameWidth,
		height: gameHeight,
		maxWidth: deviceWidth
	},
	physics: {
		default: 'arcade',
		arcade: {
			gravity: false
		}
	},
	scene: [Index, Preloader, Sounds, Utils, World, Menu, XMLLoader, Intro, Guide, Navigate, Overlay, AuntyKewa, Wharenui, KaumatuaPorch, Kaumatua, Dictionary, Matching],
	//scene: [Index, Preloader, Sounds, Utils, World, Menu, XMLLoader, Intro, Guide, Navigate],
	plugins: {
		global: [{
				key: 'TagTextPlugin',
				plugin: TagTextPlugin,
				start: true
			},
			NineSlicePlugin.DefaultCfg
		]
	},
	audio: {
		disableWebAudio: false

	},
	dom: {
		createContainer: true
	},
	fps: {
		target: 30
	}


}


class Game extends Phaser.Game {
	constructor() {
		super(config);
	}
}
//export default new Phaser.Game(config)
var game = new Game();